var map = {
	"./15.png": 7356,
	"./20.png": 9852,
	"./25.png": 3105,
	"./30.png": 6839,
	"./35.png": 954,
	"./40.png": 1290,
	"./45.png": 7175,
	"./degree.png": 3786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8453;